import { SET_ALL_PRODUCTS, SET_PRODUCT, SET_FILTERS, SET_RESULTS } from "../actions/types";
import update from 'immutability-helper';

const initialState = {
    all:[],
    filters:[],
    results:[]
}
  
export function SetAllProducts(state = initialState, action){
    switch(action.type){
        case SET_RESULTS:
            return update(state, { results:{$set:action.payload}});
    
        case SET_FILTERS:
            return update(state, { filters:{$set:action.payload}});

        case SET_ALL_PRODUCTS:
            return update(state, { all:{$set:action.payload}});
        default:
            return state;        
    }
}

export function SetProduct(state = {}, action){
    switch(action.type){
        case SET_PRODUCT:
            return action.payload;
        default:
            return state;        
    }
}
